import React, { useState, useEffect } from 'react';

const Hero = () => {
  const images = [
    {
      src: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/dd9dd189-709b-4e4b-ae23-030052c6e4f6.webp',
      alt: 'Modern luxury glass elevator in contemporary building lobby'
    },
    {
      src: '/images/stair1.jpg',
      alt: 'Curved stairlift on elegant staircase'
    },
    {
      src: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/af029fcf-8fdf-4ac4-9162-961e10e9dd3d.webp',
      alt: 'Curved stairlift on elegant staircase'
    }, 
    {
      src: '/images/stair2.jpg',
      alt: 'Curved stairlift on elegant staircase'
    },
    {
      src: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/1c07fa94-1edc-4f88-9f08-378b6d7c7bb5.webp',
      alt: 'Straight staircase with modern design'
    },
    {
      src: '/images/stair3.jpg',
      alt: 'Curved stairlift on elegant staircase'
    },
    {
      src: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/7454d717-30df-400f-9d10-25dbce20ca09.webp',
      alt: 'Floating stair architectural feature'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <section className="relative h-[400px] sm:h-[500px] md:h-[600px] lg:h-[800px] bg-premium-dark mt-20 overflow-hidden">
      <div className="absolute inset-0">
        {images.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
              index === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
      
      {/* Navigation Arrows */}
      <button
        onClick={goToPrevious}
        className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-10 bg-white/20 hover:bg-white/30 text-white p-2 sm:p-3 rounded-full transition-all backdrop-blur-sm"
        aria-label="Previous image"
      >
        <i className="fa-solid fa-chevron-left text-base sm:text-xl"></i>
      </button>
      <button
        onClick={goToNext}
        className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-10 bg-white/20 hover:bg-white/30 text-white p-2 sm:p-3 rounded-full transition-all backdrop-blur-sm"
        aria-label="Next image"
      >
        <i className="fa-solid fa-chevron-right text-base sm:text-xl"></i>
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 z-10 flex space-x-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              index === currentIndex
                ? 'bg-premium-gold w-8'
                : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
